// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"om_a bfq_vp bfq_iv bfq_wc bfq_i bfq_j bfq_q bfq_um bfq_en bfq_rh bfq_ri bfq_cx","ReplyButton__icon":"om_b bfq_rc"};